<template>
  <router-view />
</template>

<script>
export default {
  name: 'Base'
}
</script>